import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, packageExports, } = linkedPackage('lincd-storage');
//# sourceMappingURL=package.js.map